import { useEffect, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import { Dropdown, Menu, Button, Badge } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { viewCategoryList } from "../../Redux/Actions/categoryResaleActions";
import TableComponent from "../../Global Functions/tableComponents";

const CategoriesMain = () => {
  const dispatch = useDispatch();

  // const STALE_TIME = process.env.REACT_APP_STALE_TIME;

  const [searchQuery, setSearchQuery] = useState("");

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const { categories, loading } = useSelector((state) => state.categoriesResale);
  
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const fetchDetails = (page, pageSize) => {
    const categoryData = {
      page,
      limit: pageSize,
      filter: searchQuery,
    };
    dispatch(viewCategoryList(categoryData));
    // const isStale = !lastFetched || Date.now() - lastFetched > STALE_TIME; // to be used when there are no new categories, prevents un necessary render
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (categories?.total) {
      setPagination((prevData) => ({ ...prevData, total: categories.total }));
    }
  }, [categories]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const getDropDownMenu = (record) => (
    <Menu>
      <Link to={`/categories_resale/view/${record._id}`}>
        <Menu.Item key="view">View</Menu.Item>
      </Link>
      {canEdit &&
        <Link to={`/categories_resale/edit/${record._id}`}>
          <Menu.Item key="edit">Edit</Menu.Item>
        </Link>
      }
    </Menu>
  );

  const columns = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Category Name",
      dataIndex: "name",
      align: "center",
      key: "name",
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "imageUrl",
      align: "center",
      render: (image) => (
        <img
          src={image}
          alt=""
          style={{ borderRadius: "50px", width: "50px", height: "50px" }}
        />
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            border: "1px solid #d9d9d9", // Light gray border
            borderRadius: "10px", // Rounded edges
          }}
        >
          <Badge
            color={status === "active" ? "green" : "red"}
            text={status.charAt(0).toUpperCase() + status.slice(1) || ""}
            background
          />
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Dropdown overlay={getDropDownMenu(record)} trigger={["click"]}>
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    },
  ];

  const filterHandler = () => {
    setPagination((prev) => ({ ...prev, current: 1 }));
    fetchDetails(1, pagination.pageSize, searchQuery);
  };

  return (
    <TableComponent
      h3heading="Categories Resale List"
      buttonhead2={canAdd ? "Add Category" : null}
      navigateTo2={canAdd ? "/categories_resale/add" : null}
      filterFunction={filterHandler}
      setState={setSearchQuery}
      columns={columns}
      dataSource={Array.isArray(categories?.data) ? categories.data : []}
      rowKey="_id"
      loading={loading}
      pagination={pagination}
      onChange={handleTableChange}
    ></TableComponent>
  );
};

export default CategoriesMain;
